module.exports = __webpack_public_path__ + "img/Rangers.71f88089.jpg";